//=====================================================
//　入力項目補助関数
//=====================================================

//Refの入力値を取得する
export function getRef(ref:React.RefObject<HTMLInputElement>):string {
    if (ref === null){
        return ""
    } else {
        if (ref.current === null){
            return "";
        } else {
            return ref.current.value;
        }
    }
}

//Refの初期値を設定する
export function setRef(ref:React.RefObject<HTMLInputElement>, value:string) {
    if (ref !== null){
        if (ref.current !== null){
             ref.current.value = value;
        }
    }
}

//RefTextAreaの入力値を取得する
export function getRefTextArea(ref:React.RefObject<HTMLTextAreaElement>):string {
    if (ref === null){
        return ""
    } else {
        if (ref.current === null){
            return "";
        } else {
            return ref.current.value;
        }
    }
}

//RefTextAreaの初期値を設定する
export function setRefTextArea(ref:React.RefObject<HTMLTextAreaElement>, value:string) {
    if (ref !== null){
        if (ref.current !== null){
             ref.current.value = value;
        }
    }
}

//RefSelectの入力値を取得する
export function getRefSelect(ref:React.RefObject<HTMLSelectElement>):string {
    if (ref === null){
        return ""
    } else {
        if (ref.current === null){
            return "";
        } else {
            return ref.current.value;
        }
    }
}

//RefSelectの初期値を設定する
export function setRefSelect(ref:React.RefObject<HTMLSelectElement>, value:string) {
    if (ref !== null){
        if (ref.current !== null){
             ref.current.value = value;
        }
    }
}

//RefNumberの入力値を取得する
export function getRefNumber(ref:React.RefObject<HTMLInputElement>):number {
    if (ref === null){
        return 0
    } else {
        if (ref.current === null){
            return 0;
        } else {
            return ref.current.valueAsNumber;
        }
    }
}

//RefNumberの初期値を設定する
export function setRefNumber(ref:React.RefObject<HTMLInputElement>, value:number) {
    if (ref !== null){
        if (ref.current !== null){
             ref.current.valueAsNumber = value;
        }
    }
}

//RefFormの入力値を取得する
export function getRefForm(ref:React.RefObject<HTMLFormElement>):string {
    if (ref === null){
        return ""
    } else {
        if (ref.current === null){
            return "";
        } else {
            return ref.current.value;
        }
    }
}

//RefFormの初期値を設定する
export function setRefForm(ref:React.RefObject<HTMLFormElement>, value:string) {
    if (ref !== null){
        if (ref.current !== null){
             ref.current.value = value;
        }
    }
}

//チェックボックスの入力値を取得する
export function getRefCheckbox(ref:React.RefObject<HTMLInputElement>):boolean {
    if (ref === null){
        return false;
    } else {
        if (ref.current === null){
            return false;
        } else {
            return ref.current.checked;
        }
    }
}

//チェックボックスの初期値を設定する
export function setRefCheckbox(ref:React.RefObject<HTMLInputElement>, value:boolean) {
    if (ref !== null){
        if (ref.current !== null){
            ref.current.checked = value;
        }
    }
}

//対象のRefの活性制御をする
export function setRefDisabled(ref:React.RefObject<HTMLInputElement>, value:boolean) {
    if (ref !== null){
        if (ref.current !== null){
            ref.current.disabled = value;
        }
    }
}